import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQueryWithReauth } from './customQueries'
import { MACHINES_TAG, ORDER_TAG } from './tags'

export const api = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
  tagTypes: [ORDER_TAG, MACHINES_TAG],
})

export const injectEndpoints = api.injectEndpoints.bind(api)
